import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Card, Icon } from "semantic-ui-react";

import LinkWithReset from "../utils/LinkWithReset.jsx";

import { ROUTES } from "../../constants/routing.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class ProjectWizardConfigCard extends PureComponent {
  static propTypes = {
    configId: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    copyKey: PropTypes.string.isRequired
  };

  static defaultProps = {
    configId: "default",
    icon: "sitemap",
    copyKey: "project_wizard_config_selector.default"
  };

  render() {
    const { configId, icon, copyKey, copy } = this.props;

    return (
      <Card as={LinkWithReset} to={`${ROUTES.PROJECT_WIZARD}/${configId}`}>
        <Card.Content textAlign="center">
          <Icon
            circular
            inverted
            color="orange"
            name={icon}
            size="huge"
            style={{ marginTop: "0.2em", marginBottom: "0.2em" }}
          />
        </Card.Content>
        <Card.Content>
          <Card.Header>{copy(`${copyKey}.title`)}</Card.Header>
          <Card.Description>{copy(`${copyKey}.description`)}</Card.Description>
        </Card.Content>
      </Card>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ProjectWizardConfigCard);
